module.exports = "build/assets/RingsideRegular-Med.0e39abd9.woff";